import React from "react";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <React.Fragment>
      <section className="loginswallow-dashboard">
        <div className="page-not-found">
          <h1>404 - Page Not Found</h1>
          <p>The page you are looking for does not exist.</p>
          <Link to="/">Go to Home</Link> {/* Redirect to home page */}
        </div>
      </section>
    </React.Fragment>
  );
}

export default NotFound;
